import React from 'react';
import { DateField, LanguageShortField } from 'framework/ui/field';
import { Box } from '@mui/material';
import AssessmentLevelWithDetailsFields from './shared/fields/AssessmentLevelWithDetailsFields';
import DeleteAssessmentButton from 'domain/people/employee/assessment/List/button/DeleteAssessmentButton';
import EditAssessmentButton from 'domain/people/employee/assessment/List/button/EditAssesmentButton';

const AssessmentItem = () => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb="5px">
      <LanguageShortField source="assignmentLanguage" />
      <AssessmentLevelWithDetailsFields source="levelAssignment" />
      <DateField label="" source="assessmentDate" />

      <Box display="flex" alignItems="center" gap="10px">
        <EditAssessmentButton source="id" />
        <DeleteAssessmentButton source="id" />
      </Box>
    </Box>
  );
};

export default AssessmentItem;
